module.exports = __webpack_public_path__ + "img/bttn-grid-on.92fc1623.svg";